import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { LinkAsButton } from '@printdeal/ui-library';
// @ts-expect-error
import { getLocalized } from '../../../../../helpers/getLocalisedData';
import { QuoteLineItem as QuoteLineItemType } from '../../../../../types/quotes/quoteLineItems';

const QuoteLineItem = ({ lineItem }: { lineItem: QuoteLineItemType }) => {
  const { locale } = useIntl();
  const {
    productDescription,
    arrivalDate,
  } = lineItem;
  const [isFullDescriptionOpen, setIsFullDescriptionOpen] = useState(false);
  const toggleFullDescription = () => setIsFullDescriptionOpen(!isFullDescriptionOpen);
  const localizedDescription = getLocalized(locale, productDescription);
  const descriptionArray = localizedDescription.split(', ');

  return (
    <div className="pd-flex pd-flex-col pd-gap-4">
      {arrivalDate && <FormattedMessage id="lineItems.list.arrivalDate" defaultMessage="Arrival Date: {arrivalDate} If ordered today." values={{ arrivalDate }} />}
      <div className="pd-z-10 pd-shrink pd-justify-self-start">
        <ul>
          {descriptionArray.slice(0, 3).map((descriptionItem: string) => (
            <li key={descriptionItem}>
              {descriptionItem}
            </li>
          ))}
        </ul>
        {descriptionArray.length > 3 && (
        <>
          {isFullDescriptionOpen && (
          <ul className="pd-mt-2">
            {descriptionArray.slice(3).map((descriptionItem: string) => (
              <li key={descriptionItem}>
                {descriptionItem}
              </li>
            ))}
          </ul>
          )}
          <LinkAsButton
            type="button"
            variant="secondary"
            iconBefore={`double-chevron-${isFullDescriptionOpen ? 'up' : 'down'}`}
            onClick={toggleFullDescription}
            className="pd-my-2 pd-text-xs"
          >
            {isFullDescriptionOpen
              ? <FormattedMessage id="lineItems.list.hideFullDescription" defaultMessage="Show less" />
              : <FormattedMessage id="lineItems.list.showFullDescription" defaultMessage="Show more" />}
          </LinkAsButton>
        </>
        )}
      </div>
    </div>
  );
};

export default QuoteLineItem;
